import styled from 'styled-components';

const InvoiceHeaderWrapper = styled.div`
    padding: 0 0 15px;
    border-bottom: 1px solid #dee2e6;
`;

export default InvoiceHeaderWrapper;